module.exports = __webpack_public_path__ + "img/features-4.09e411f1.png";